/* src/app/shared/components/shimmer/shimmer.component.scss */
.shimmer-container {
  display: flex;
  flex-direction: column;
  gap: 0;
}
/*# sourceMappingURL=shimmer.component.css.map */
